import { render, staticRenderFns } from "./liveGroupModal.vue?vue&type=template&id=9e6a71d4&scoped=true"
import script from "./liveGroupModal.vue?vue&type=script&lang=js"
export * from "./liveGroupModal.vue?vue&type=script&lang=js"
import style0 from "./liveGroupModal.vue?vue&type=style&index=0&id=9e6a71d4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e6a71d4",
  null
  
)

export default component.exports